import {chain} from "@Common/utils/fs";

export const groupSections = (sections) => {
    const invalid = sections.find((s) => s?.invalid);
    return ({
        errorMessages: sections.map((s) => s?.errorMessages ?? []).flat(),
        beforeCheckout: async () => {
            for (const section of sections) {
                await section?.beforeCheckout?.();
            }
        },

        invalid,
        ...invalid && chain(
            sections.find((s) => s && s.invalid && s.highlightErrors),
            (_) => _ && ({highlightErrors: _.highlightErrors}),
        ),
    });
};
